import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { mapValues } from "lodash";
import EditEmailModuleToolbar from "./EditEmailModuleToolbar";
import ErrorAlert from "../../components/ErrorAlert";
import EmailModule from "../../components/EmailModule";
import Popup from "../../components/Popup";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import AceEditorDefaultValue from "../../components/AceEditorDefaultValue";
import {
  fetchModule,
  emailModuleSetKeyValue,
  toggleEditModulePreview,
} from "../../actions";

function fieldsDataToModuleData(fields) {
  return mapValues(fields, (value, key) => {
    if (value.type === "group") {
      return fieldsDataToModuleData(value);
    }
    return value.defaultValue;
  });
}

export class EditEmailModulePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
    };
    this.onHtmlChange = this.onHtmlChange.bind(this);
    this.onCssChange = this.onCssChange.bind(this);
    this.onDataChange = this.onDataChange.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  componentWillMount() {
    const { id } = this.props.match.params;
    const { accountId } = this.props.match.params;

    this.props.fetchModule(accountId, id);
  }

  onHtmlChange(newValue) {
    this.props.emailModuleSetKeyValue("template", newValue);
  }

  onCssChange(newValue) {
    this.props.emailModuleSetKeyValue("style", newValue);
  }

  onDataChange(newValue) {
    try {
      const data = JSON.parse(newValue);
      this.props.emailModuleSetKeyValue("fields", data);
    } catch (e) { }
  }

  togglePopup() {
    this.setState({
      showPopup: !this.state.showPopup,
    });
    this.props.toggleEditModulePreview();
  }

  closePopup() {
    this.setState({
      showPopup: false,
    });
    this.props.toggleEditModulePreview();
  }

  render() {
    const {
      emailModule,
      showHtml,
      showCss,
      showData,
      showTemplate,
      showPreview,
      displayWidth,
    } = this.props;
    const { accountId } = this.props.match.params;
    const fields = emailModule.fields || {};

    const moduleData = Object.assign(
      {},
      fieldsDataToModuleData(fields.data || {}),
      {
        country: "uk",
        subject: "Email Subject",
      }
    );

    const numColumns =
      (showHtml ? 1 : 0) +
      (showCss ? 1 : 0) +
      (showData ? 1 : 0) +
      (showTemplate ? 1 : 0) +
      (showPreview ? 1 : 0);

    const columnWidth = 100 / numColumns + "%";

    if (emailModule.failed) {
      return (
        <ErrorAlert title="404">
          <Link to={`/clients/${accountId}/email-modules`}>Return to list</Link>
        </ErrorAlert>
      );
    }

    if (!emailModule.id) {
      return <div />;
    }

    const dataJson = JSON.stringify(
      Object.assign({}, moduleData, { template: emailModule.template })
    );
    const url =
      emailModule.id && accountId
        ? `${process.env.REACT_APP_API_ENDPOINT
        }/api/clients/${accountId}/email-modules/${emailModule.id
        }/html?data=${encodeURIComponent(dataJson)}&email=${""}&var=${""}`
        : "about:blank";

    return (
      <div key={emailModule.id}>
        <Helmet>
          <title>{`Mercury - ${emailModule.name}`}</title>
        </Helmet>
        <EditEmailModuleToolbar accountId={accountId} />
        <div
          style={{
            position: "fixed",
            top: 97,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
          }}
        >
          {showHtml && (
            <div style={{ width: columnWidth, height: "100%" }}>
              <AceEditorDefaultValue
                key={`${showHtml}${showCss}${showData}${showTemplate}${showPreview}`}
                mode="handlebars"
                theme="monokai"
                onChange={this.onHtmlChange}
                name="module_html"
                width="100%"
                height="100%"
                editorProps={{ $blockScrolling: true }}
                defaultValue={emailModule.template}
              />
            </div>
          )}
          {showCss && (
            <div style={{ width: columnWidth, height: "100%" }}>
              <AceEditorDefaultValue
                key={`${showCss}${showData}${showTemplate}${showPreview}${showHtml}`}
                mode="handlebars"
                theme="monokai"
                onChange={this.onCssChange}
                name="module_css"
                width="100%"
                height="100%"
                editorProps={{ $blockScrolling: true }}
                defaultValue={emailModule.style}
              />
            </div>
          )}
          {showData && (
            <div
              style={{
                width: columnWidth,
                height: "100%",
                background: "#444",
                overflow: "auto",
              }}
            >
              <AceEditorDefaultValue
                key={`${showData}${showTemplate}${showPreview}${showHtml}${showCss}`}
                mode="json"
                theme="monokai"
                onChange={this.onDataChange}
                name="module_data"
                width="100%"
                height="100%"
                editorProps={{ $blockScrolling: true }}
                defaultValue={JSON.stringify(emailModule.fields, null, 4)}
              />
            </div>
          )}
          {showTemplate && (
            <div
              style={{
                width: columnWidth,
                height: "100%",
                background: "#444",
                overflow: "auto",
              }}
            >
              <AceEditorDefaultValue
                key={`${showTemplate}${showPreview}${showHtml}${showCss}${showData}`}
                mode="handlebars"
                theme="monokai"
                name="module_template"
                readOnly="true"
                width="100%"
                height="100%"
                editorProps={{ $blockScrolling: true }}
                defaultValue={emailModule.EmailTemplate.template}
              />
            </div>
          )}
          {showPreview && (
            <div
              style={{
                width: columnWidth,
                height: "100%",
                background: "#333",
                overflow: "auto",
              }}
            >
              <div style={{ padding: 15 }}>
                <div style={{ width: displayWidth }}>
                  <EmailModule
                    id={emailModule.id}
                    accountId={accountId}
                    data={moduleData}
                    template={emailModule.template}
                    style={emailModule.style}
                    editor
                  />
                </div>
              </div>
              <Button
                onClick={this.togglePopup}
                color="greyed"
                style={{ position: "absolute", right: 0, bottom: 10 }}
              >
                <Icon icon="external-link-square" title="Open popup" />
              </Button>
            </div>
          )}
          {numColumns === 0 && (
            <div
              style={{
                width: "100%",
                height: "100%",
                background: "#333",
                color: "#444",
                fontSize: 300,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Icon icon="bolt" />
            </div>
          )}
          {this.state.showPopup && (
            <Popup url={url} width={displayWidth} onClose={this.closePopup} />
          )}
        </div>
      </div>
    );
  }
}

EditEmailModulePage.propTypes = {
  fetchModule: PropTypes.func.isRequired,
  emailModuleSetKeyValue: PropTypes.func.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const {
    emailModule,
    showHtml,
    showCss,
    showData,
    showTemplate,
    showPreview,
  } = state.emailModuleEditor;
  const { displayWidth } = state.editor;

  return {
    emailModule,
    showHtml,
    showCss,
    showData,
    showTemplate,
    showPreview,
    displayWidth,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  fetchModule,
  emailModuleSetKeyValue,
  toggleEditModulePreview,
})(EditEmailModulePage);
